// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-range-picker {
  width: 231px;
  height: 36px;
  border: 1px solid #c5c5c7;
  border-radius: 10px;
  justify-content: center;
  padding-left: 30px;
}
.react-datepicker__calendar-icon {
width: 20px;
height: 20px;
}
.react-datepicker__view-calendar-icon input{
  padding: 0px 10px 0px 35px;
}`, "",{"version":3,"sources":["webpack://./src/components/dateRangePicker/dateRangePicker.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;AACA,WAAW;AACX,YAAY;AACZ;AACA;EACE,0BAA0B;AAC5B","sourcesContent":[".date-range-picker {\n  width: 231px;\n  height: 36px;\n  border: 1px solid #c5c5c7;\n  border-radius: 10px;\n  justify-content: center;\n  padding-left: 30px;\n}\n.react-datepicker__calendar-icon {\nwidth: 20px;\nheight: 20px;\n}\n.react-datepicker__view-calendar-icon input{\n  padding: 0px 10px 0px 35px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
